module.exports = __webpack_public_path__ + "static/img/20-mandarin.dca33947.png";